<template>

  <el-collapse-item name="子标题" title="子标题">
    <el-form-item label="文本">
      <el-input v-model="ele.option.title.subtext"></el-input>
    </el-form-item>
    <el-form-item label="字体大小">
      <el-input v-model="ele.option.title.subtextStyle.fontSize"></el-input>
    </el-form-item>
    <el-form-item label="文本颜色">
      <el-color-picker v-model="ele.option.title.subtextStyle.color"
                       :predefine="['rgba(255, 255, 255, 1.0)','#ff4500',  '#ff8c00',  '#ffd700', '#90ee90',  '#00ced1', '#1e90ff',  '#c71585',  'rgba(255, 69, 0, 0.68)',  'rgb(255, 120, 0)',  'hsv(51, 100, 98)', 'hsva(120, 40, 94, 0.5)', 'hsl(181, 100%, 37%)', 'hsla(209, 100%, 56%, 0.73)','#c7158577']"
                       show-alpha>
      </el-color-picker>
    </el-form-item>

    <el-form-item label="超链接">
      <el-input v-model="ele.option.title.sublink"></el-input>
    </el-form-item>
  </el-collapse-item>

</template>


<script>
export default {

  props: {
    element: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      ele: null
    }
  },
  created() {
    this.ele = this.element;
  },

}

</script>

<style scoped lang="scss">

</style>